import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBee3mvkG6VY0GOQjKZAFQ1fuZBregpKNk",
  authDomain: "clone-8bfdb.firebaseapp.com",
  databaseURL: "https://clone-8bfdb.firebaseio.com",
  projectId: "clone-8bfdb",
  storageBucket: "clone-8bfdb.appspot.com",
  messagingSenderId: "919713541134",
  appId: "1:919713541134:web:5a5612bcaea3af3507605f",
  measurementId: "G-EGEW5C9WQZ",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
